import { Component } from "@angular/core";


@Component({
    selector: 'm4u-injector',
    template: ''
})
export class InjectorComponent {
}